// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2r4fI","footer":"Form_footer__2uvPi"};